import Cleave from 'cleave.js';
import Cookies from 'js-cookie';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

const $ = jQuery;

const freeEmailDomains = [
    '10minutemail',
    'aol',
    'fastmail',
    'gmail',
    'gmx',
    'hotmail',
    'icloud',
    'inbox',
    'live',
    'mail',
    'email',
    'outlook',
    'protonmail',
    'yahoo',
    'yandex',
    'zoho',
    'zohomail',
];

const isFreeEmail = (domain) => {
    let isFree = false;
    freeEmailDomains.forEach((freeDomain) => {
        if (domain.indexOf(freeDomain + '.') === 0) {
            isFree = true;
        }
    });
    return isFree;
};

const isValidEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
};

// window.initCCConvertion = function(val) {
//     window.ccConVal = val || 0;
//     var script = document.createElement('script');
//     var target = 'https://www.clickcease.com/monitor/cccontrack.js';
//     var elem = document.head;
//     script.type = 'text/javascript';
//     script.src = target;
//     elem.appendChild(script);
// }

const decodeJwtResponse = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
        .split('')
        .map((c) => ('%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)))
        .join('')
    );
    return JSON.parse(jsonPayload);
};

let step = 1;
let googleUser = null;

const googleOnSignIn = (response) => {
    googleUser = decodeJwtResponse(response.credential);

    const parts = googleUser.email.split('@');
    if (isFreeEmail(parts[1])) {
        googleUser = null;
        const errorMessage = $('div.sign-up-google-container .error-message-field');
        errorMessage.html('Please use a business email address. If you don\'t have one, <a href="/sp-sign-up/">contact us here</a> to set up your workspace.').show();
        return;
    }

    $('.trial-form input[name="user_email"]').val(googleUser.email).trigger('change');
    $('.trial-form input[name="user_first_name"]').val(googleUser.given_name).trigger('change');
    $('.trial-form input[name="user_last_name"]').val(googleUser.family_name).trigger('change');
    $('.trial-form input[name="google_auth_credential"]').val(response.credential).trigger('change');

    step = 2;
    $('.trial-form label[for="first_name"]').hide();
    $('.trial-form label[for="last_name"]').hide();
    $('.sign-up-form-step-1').addClass('hidden');
    $('.sign-up-form-step-2').removeClass('hidden');
    $('.trial-form .current-user span').html($('.trial-form input[name="user_email"]').val());
};

$(window).load(function() {
    google.accounts.id.initialize({
      client_id: ajax_object.google_auth_client_id,
      callback: googleOnSignIn,
    });
    const button = document.getElementById('google-sign-in-button');
    if (button) {
        button.classList.remove('disabled');
    }
    google.accounts.id.renderButton(document.getElementById('gsi-button'), { width: 400 });
});

$(document).ready(function() {
    if ($('.stockpress-trial-form').length === 0) {
        return;
    }

    tippy('#domain-tooltip', {
        content: document.getElementById('domain-tooltip-content').innerHTML,
        interactive: true,
        allowHTML: true,
    });

    let fundingField = null;
    if ($('.trial-form input[name="company_funding"]').length > 0) {
        fundingField = new Cleave('.trial-form input[name="company_funding"]', {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
            numeralPositiveOnly: true,
            prefix: '$',
        });
    }

    $('.trial-form').on('click', 'button.sign-up-continue', function(e) {
        e.preventDefault();
        step = 2;
        $('.sign-up-form-step-1').addClass('hidden');
        $('.sign-up-form-step-2').removeClass('hidden');
        $('.trial-form .current-user span').html($('.trial-form input[name="user_email"]').val());
        $('.trial-form label[for="first_name"]').show();
        $('.trial-form label[for="last_name"]').show();
    });

    $('.trial-form').on('click', '.change-user', function(e) {
        e.preventDefault();
        step = 1;
        $('.sign-up-form-step-1').removeClass('hidden');
        $('.sign-up-form-step-2').addClass('hidden');
        $('.trial-form label[for="first_name"]').show();
        $('.trial-form label[for="last_name"]').show();
    });

    $('.trial-form').on('change keyup', 'input[name="user_email"]', function() {
        const type = $('input[name="company_type"]').val();
        if (type === 'nonprofit' || type === 'startup') {
            $('.trial-form').find('button[type="submit"]').removeAttr('disabled');
        }

        $('div.sign-up-google-container .error-message-field').hide();
        const label = $('label[for="email"]');
        const errorMessage = label.find('.error-message-field');
        errorMessage.hide();
        let formDisabled = false;
        const email = $(this).val().toLowerCase();
        const parts = email.split('@');
        let domain = '';
        if (parts[1]) {
            domain = parts[1].split('.')[0];
            if (isFreeEmail(parts[1])) {
                domain = parts[0];
                if ($('.trial-form input[name="manual_signup"]').length === 0) {
                    formDisabled = true;
                    if (isValidEmail(email)) {
                        errorMessage.html('Please use a business email address. If you don\'t have one, <a href="/sp-sign-up/">contact us here</a> to set up your workspace.').show();
                    }
                }
            }
        }
        $('.trial-form input[name="company_subdomain"]').val(domain.replace(/[^a-zA-Z0-9]/g, ''));

        if (!isValidEmail(email)) {
            formDisabled = true;
        }

        if (formDisabled) {
            $('.trial-form').find('button[type="submit"]').attr('disabled', true);
        } else {
            $('.trial-form').find('button[type="submit"]').removeAttr('disabled');
        }
    });

    $('.trial-form').on('change keyup', 'input[name="company_name"]', function() {
        const type = $('input[name="company_type"]').val();
        if (!(type === 'nonprofit' || type === 'startup')) {
            return;
        }

        $('.trial-form input[name="company_subdomain"]').val($(this).val().replace(/[^a-zA-Z0-9]/g, '').toLowerCase());
    });

    $('.trial-form').on('submit', 'form.stockpress-trial-form', function(e) {
        e.preventDefault();

        const form = $(this);
        let error = false;
        form.find('.error-message-field').hide();
        form.find('input,select').removeClass('error');
        const attrs = {};
        form.find('input[required],select[required]').each(function() {
            form.removeClass('error');
            let value = $(this).val();
            if ($(this).attr('name') == 'company_funding') {
                value = fundingField.getRawValue().replace('$', '');
            }

            if (value == '') {
                $(this).addClass('error');
                error = true;
            }

            if ($(this).attr('name') == 'terms' && !$(this).is(':checked')) {
                $(this).addClass('error');
                error = true;
            }
            attrs[$(this).attr('name')] = value;
        });
        attrs.referrer = $('input[name="referrer"]').val();
        attrs.source_url = $('input[name="source_url"]').val();
        if ($('input[name="google_auth_credential"]').val()) {
            attrs.google_auth_credential = $('input[name="google_auth_credential"]').val();
        }
        attrs.source = $('input[name="source"]').val() || 'website';
        if ($('input[name="manual_signup"]').length > 0) {
            attrs.manual_signup = $('input[name="manual_signup"]').val();
        }
        attrs.n_password = $('input[name="n_password"]').val();
        attrs.how_did_you_hear = $('textarea[name="how_did_you_hear_about_us___dark_funnel_"]').val();

        if (error) {
            form.find('.error-message').show();
            $('html,body').animate({ scrollTop: form.offset().top - 50 });
            return;
        } else {
            form.find('.error-message').hide();
        }

        if (window.Intercom) {
            const intercomId = window.Intercom('getVisitorId');
            if (intercomId) {
                attrs.intercom_id = intercomId;
            }
        }

        const button = form.find('button[type="submit"]');
        button.attr('disabled', true);
        button.html('Please wait...');
        form.find('input,select').attr('disabled', true);

        attrs.action = 'stockpress_trial';

        grecaptcha.ready(function() {
            grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function(token) {
                attrs.token = token;
                $.ajax({
                    url: ajax_object.ajax_url,
                    type: 'post',
                    data: attrs,
                    dataType: 'json',
                    success: function(response) {
                        const { data } = response;
                        if (data.status == 'success') {
                            if (window.initCCConvertion) {
                                window.initCCConvertion();
                            }
                            if (window.dataLayer) {
                                window.dataLayer.push({
                                    'form_id': 'website_signup',
                                    'event': 'account_signup',
                                });
                            }

                            // Reditus conversion
                            if (window.gr) {
                                window.gr('track', 'conversion', { email: attrs.email });
                            }

                            // Mixpanel event
                            if (window.mixpanel) {
                                window.mixpanel.track('Sign up');
                            }

                            // PostHog event
                            if (window.posthog) {
                                window.posthog.capture('Sign up');
                            }

                            Cookies.set('sp_h_email', attrs.user_email, { expires: 90 });

                            let redirectUrl;
                            let messageClass;
                            if (attrs.google_auth_credential) {
                                redirectUrl = form.find('input[name="redirect_url_google"]').val();
                                if (!redirectUrl && data.url) {
                                    redirectUrl = data.url;
                                }
                                messageClass = 'success-message-google';
                                $('.success-message-google a').attr('href', data.url || 'https://' + attrs.company_subdomain + '.stockpress.co');
                            } else {
                                redirectUrl = `${form.find('input[name="redirect_url"]').val()}?t=${Date.now()}`;
                                messageClass = 'success-message';
                            }
                            if (redirectUrl) {
                                window.location = redirectUrl;
                            } else {
                                $('html,body').animate({ scrollTop: form.parent().offset().top - 100 });
                                form.hide();
                                form.parent().find(`.${messageClass}`).show();
                            }
                        }
                    },
                    error: function(response) {
                        const { data } = response.responseJSON;
                        if (data) {
                            Object.keys(data).forEach(function(key) {
                                if (key === 'errors' && data[key].api) {
                                    errorEl = form.find('div.api-error-message');
                                    errorEl.html(data[key].api);
                                    errorEl.show();
                                }
                                const el = form.find('input[name="' + key + '"],select[name="' + key + '"]');
                                let errorEl = el.parent('label').find('div.error-message-field');
                                if (errorEl) {
                                    el.addClass('error');
                                }
                                errorEl.html(data[key]);
                                errorEl.show();
                                $('html,body').animate({ scrollTop: form.offset().top - 50 });
                                button.removeAttr('disabled');
                                button.html('Sign up');
                                form.find('input,select').removeAttr('disabled');
                            });
                        }
                    },
                });
            });
        });
    });
});



// WEBPACK FOOTER //
// ./src/js/trial.js